"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _this = this;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var react_jss_1 = __importDefault(require("react-jss"));

var color_1 = __importDefault(require("color"));

var BurnerProvider_1 = require("../../BurnerProvider");

var Button_1 = __importDefault(require("../../components/Button"));

var Page_1 = __importDefault(require("../../components/Page"));

var PluginElements_1 = __importDefault(require("../../components/PluginElements"));

var AccountBalance_1 = __importDefault(require("../../data-providers/AccountBalance"));

var History_1 = __importDefault(require("../../data-providers/History"));

var constants_1 = require("../../constants");

var BalanceRow_1 = __importDefault(require("./BalanceRow"));

var HistoryListEvent_1 = __importDefault(require("./HistoryListEvent"));

var styles = function styles(theme) {
  return {
    balances: {
      padding: 0
    },
    buttons: {
      display: 'flex',
      padding: 0,
      flexWrap: 'wrap'
    },
    buttonContainer: {
      display: 'block',
      width: '50%',
      padding: 4,
      boxSizing: 'border-box',
      flex: '0 0 50%'
    },
    homeButton: {
      backgroundColor: theme.homeButtonColor
    },
    scanBtn: {
      position: 'fixed',
      bottom: 20,
      right: 20,
      height: 60,
      width: 60,
      borderRadius: 100,
      backgroundImage: "url(\"" + constants_1.SCAN_QR_DATAURI + "\")",
      backgroundSize: '60%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundColor: color_1.default(theme.accentColor).lighten(0.2).hsl().string()
    },
    advancedLink: {
      color: color_1.default(theme.paperBackground).isLight() ? '#333333' : '#cccccc'
    }
  };
};

var HomeButton = function HomeButton(_a) {
  var path = _a.path,
      title = _a.title,
      classes = _a.classes;
  return react_1.default.createElement("li", {
    className: classes.buttonContainer
  }, react_1.default.createElement(Button_1.default, {
    to: path,
    className: classes.homeButton
  }, title));
};

var ADDRESS_REGEX = /^(?:0x)?[0-9a-f]{40}$/i;
var PK_REGEX = /^(?:0x)?[0-9a-f]{64}$/i;

var HomePage = function HomePage(_a) {
  var accounts = _a.accounts,
      actions = _a.actions,
      assets = _a.assets,
      pluginData = _a.pluginData,
      classes = _a.classes;
  return react_1.default.createElement(Page_1.default, null, react_1.default.createElement("button", {
    className: classes.scanBtn,
    onClick: function onClick() {
      return __awaiter(_this, void 0, void 0, function () {
        var result, e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);

              return [4
              /*yield*/
              , actions.scanQrCode()];

            case 1:
              result = _a.sent();

              if (pluginData.tryHandleQR(result, {
                actions: actions
              })) {
                return [2
                /*return*/
                ];
              } else if (ADDRESS_REGEX.test(result)) {
                actions.navigateTo('/send', {
                  address: result
                });
              } else if (PK_REGEX.test(result)) {
                actions.callSigner('writeKey', accounts[0], result);
              } else if (result.indexOf(location.origin) === 0) {
                actions.navigateTo(result.substr(location.origin.length));
              }

              return [3
              /*break*/
              , 3];

            case 2:
              e_1 = _a.sent();
              return [3
              /*break*/
              , 3];

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    }
  }), react_1.default.createElement(PluginElements_1.default, {
    position: "home-top"
  }), accounts.length > 0 ? react_1.default.createElement("ul", {
    className: classes.balances
  }, assets.map(function (asset) {
    return react_1.default.createElement(AccountBalance_1.default, {
      key: asset.id,
      asset: asset.id,
      account: accounts[0],
      render: function render(err, data) {
        return react_1.default.createElement(BalanceRow_1.default, {
          asset: asset,
          usdBalance: data && data.usdBalance,
          balance: data && data.displayBalance
        });
      }
    });
  })) : 'Loading', react_1.default.createElement(PluginElements_1.default, {
    position: "home-middle"
  }), react_1.default.createElement("ul", {
    className: classes.buttons
  }, react_1.default.createElement(HomeButton, {
    path: "/receive",
    title: "Receive",
    classes: classes
  }), react_1.default.createElement(HomeButton, {
    path: "/send",
    title: "Send",
    classes: classes
  }), pluginData.homeButtons.map(function (_a) {
    var title = _a.title,
        path = _a.path;
    return react_1.default.createElement(HomeButton, {
      title: title,
      path: path,
      key: title,
      classes: classes
    });
  })), accounts.length > 0 && react_1.default.createElement(History_1.default, {
    account: accounts[0],
    render: function render(events) {
      return events.map(function (event) {
        return react_1.default.createElement(HistoryListEvent_1.default, {
          key: JSON.stringify(event),
          event: event,
          account: accounts[0],
          navigateTo: actions.navigateTo
        });
      });
    }
  }), react_1.default.createElement(PluginElements_1.default, {
    position: "home-bottom"
  }), react_1.default.createElement(react_router_dom_1.Link, {
    to: "/advanced",
    className: classes.advancedLink
  }, "Advanced"));
};

exports.default = react_jss_1.default(styles)(BurnerProvider_1.withBurner(HomePage));